import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { PosAppService } from '../services/pos.app.service';
import { Base64 } from 'js-base64';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-app-redirection',
  templateUrl: './app-redirection.component.html',
  styleUrl: './app-redirection.component.scss'
})
export class AppRedirectionComponent implements OnInit {
  loginDetails: IDPInfo = new IDPInfo;


  constructor(private activeRoute: ActivatedRoute,
    private service: LoginService,
    private posAppSvcs: PosAppService,
  ) { }


  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: any) => {
      this.loginDetails = JSON.parse(Base64.decode(params['data']));

      const authToken = this.loginDetails.extraParam['token'];

      this.posAppSvcs.setAuthToken("Bearer_" + authToken);
      // this.service.login(this.loginDetails.userID, this.loginDetails.team);  
      this.service.loadMenuData();
    });
  }


}

export class IDPInfo {
  authToken!: string;
  extraParam: any;
  department!: string;
  emailAddress!: string;
  firstName!: string;
  lastName!: string;
  team!: string;
  userID!: string;
}
